import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-img-form',
  templateUrl: './dialog-img-form.component.html',
  styleUrls: ['./dialog-img-form.component.scss']
})
export class DialogImgFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
